module.exports = __webpack_public_path__ + "img/Lopp.d647503f.jpg";